import { Box } from '@mui/material';

import { SettingsPageLayout } from '../../../components/SettingsPageLayout';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';

import DownloadSettings from './downloadSettings';

const JobsDataDownloadSettings = () => {
  return (
    <SettingsPageLayout
      title="Job's Data Download Settings"
      indexOptions={[
        { label: 'Attribute settings', url: '/jobs-download-settings' },
        // { label: 'Download Limit', url: '/limit' },
      ]}
      breadCrumnbsList={getSettingBreadCrumbList(
        ISettingBreadCrumbTypes.JOBS,
        Pages['JOB_DATA_DOWNLOAD_SETTING']
      )}
    >
      <Box component="form" p={1}>
        <DownloadSettings />
      </Box>
    </SettingsPageLayout>
  );
};

export default JobsDataDownloadSettings;
